export interface WorldpayCustomisationBorder {
  color?: string;
  radius?: string;
  style?: string;
  width?: string;
}
